import React from 'react';
import { Grid, InputLabel, OutlinedInput } from '@mui/material';
import { FieldError } from '../../../components/form-page-parts';
import { LookupSelect } from './lookup-select';
import { SupplierDocumentInput } from './supplier-document-input';
import { SUPPLIER_TYPE_OPTIONS } from './scp-utils';

export interface SupplierFieldNames {
    type: string;
    document: string;
    name: string;
}

// Tipo, documento (CPF/CNPJ/estrangeiro) e nome do fornecedor, usados em contratos e aditivos
export function SupplierFields({ names, type, document, name, onChange, required, labelSuffix = '', errors = {} }: {
    names: SupplierFieldNames;
    type?: string | null;
    document?: string | null;
    name?: string | null;
    onChange: (e: any) => void;
    required?: boolean;
    labelSuffix?: string;
    errors?: { type?: string; document?: string; name?: string };
}) {
    return (
        <React.Fragment>
            <Grid item xs={12} sm={6} md={3} lg={2}>
                <LookupSelect required={required} label={`Tipo Fornecedor${labelSuffix}`} name={names.type} value={type} options={SUPPLIER_TYPE_OPTIONS} onChange={onChange} error={errors.type} emptyLabel="Selecionar" />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <SupplierDocumentInput required={required} name={names.document} supplierType={type} value={document} onChange={onChange} error={errors.document} labelSuffix={labelSuffix} />
            </Grid>
            <Grid item xs={12} md={5} lg={7}>
                <InputLabel required={required}>{`Nome do Fornecedor${labelSuffix}`}</InputLabel>
                <OutlinedInput fullWidth autoComplete="off" name={names.name} value={name || ''} onChange={onChange} error={!!errors.name} />
                <FieldError message={errors.name} />
            </Grid>
        </React.Fragment>
    );
}
